import { createSlice } from '@reduxjs/toolkit'

import { databaseSelectors } from '../selectors/database'

const initialState = {
    table: '',
    tableData: [],
    referenceOptions: {},
    loading: false,
    referencesLoading: false,
    adding: false,
    saving: false,
    deleting: false,
    error: null,
    addError: null,
    editError: null,
}

const database = createSlice({
    name: 'database',
    initialState,
    reducers: {
        setTable: (state, action) => {
            state.table = action.payload
        },
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
        setReferenceOptions: (state, action) => {
            state.referenceOptions = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setReferencesLoading: (state, action) => {
            state.referencesLoading = action.payload
        },
        setAdding: (state, action) => {
            state.adding = action.payload
        },
        setSaving: (state, action) => {
            state.saving = action.payload
        },
        setDeleting: (state, action) => {
            state.deleting = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        setAddError: (state, action) => {
            state.addError = action.payload
        },
        setEditError: (state, action) => {
            state.editError = action.payload
        },
        clearErrors: (state) => {
            state.error = null
            state.addError = null
            state.editError = null
        },
    },
    selectors: {
        ...databaseSelectors,
    },
})

export const databaseSelector = database.getSelectors()
export const databaseActions = database.actions

export default database.reducer
